import PageSection from '@product-framework/components/PageSection';
import FormActionDialog from '@ui-framework/components/AdvancedForms/FormActionDialog';
import { useEffect, useRef, useState } from 'react';
import {
  CRUD_COMPONENT_TYPE,
  CRUDComponent,
  useDataProvider,
  useLocalization,
} from '@ui-framework/index';
import listSchema from './list.json';
import {
  effectiveStartDate,
  effectiveEndDate,
  buttonActions,
} from './accessorFunctions';

function DefaultSchedulesList({
  params,
  currentView,
  setCurrentView,
  selectedScheduleId,
  setSelectedScheduleId,
  refreshListView,
  locationId = null,
}) {
  const deleteActionDialog = useRef(null);
  const provider =
    process.env.NODE_ENV === 'development' ? 'sxclServices' : 'default';
  const dataProvider = useDataProvider(provider);
  const { formatMessage } = useLocalization();
  const serviceProviderId = params?.pageId;

  const [rowSelection, setRowSelection] = useState(null);

  const locationParam = locationId ? `/location/${locationId}` : '';
  const listApiUrl = `${dataProvider.getApiUrl()}/sxcl/v1/availability/service-providers/${serviceProviderId}${locationParam}/default-schedules`;

  const listProps = {
    columnPrimaryId: 'id',
    storeName: locationId
      ? 'LocationDefaultSchedulesList'
      : 'SPDefaultSchedulesList',
    dataProvider,
    schema: listSchema,
    initialState: {
      showColumnFilters: false,
    },
    downloadApiUrl: null,
    listApiUrl,
    accessorFunctions: {
      effectiveStartDate,
      effectiveEndDate,
      buttonActions,
    },
    accessorFunctionsAdditional: {
      currentView,
      setCurrentView,
      selectedScheduleId,
      setSelectedScheduleId,
      setRowSelection,
      rowSelection,
      deleteActionDialog: deleteActionDialog.current,
      refreshListView,
      params,
      formatMessage,
      locationId,
    },
    rowSelection,
    sortOrder: 'ASC',
    sortBy: 'effectiveStartDate',
  };

  // Highlight the selected record
  useEffect(() => {
    setRowSelection({ [selectedScheduleId]: true });
  }, [selectedScheduleId]);

  return (
    <PageSection
      subSection
      label={formatMessage({
        id: 'DEFAULT_SCHEDULES_LIST',
        defaultMessage: 'Default Schedules List',
      })}>
      <CRUDComponent
        type={CRUD_COMPONENT_TYPE.ADVANCED_LIST}
        listProps={listProps}
      />
      <FormActionDialog ref={deleteActionDialog} />
    </PageSection>
  );
}

export default DefaultSchedulesList;
